module.exports = __webpack_public_path__ + "media/2-1.7780a421.wav";